// removed by extract-text-webpack-plugin
module.exports = {"hint":"Q81up85P1UYviOSj92Eou","isWarning":"_3n8EKHsmklZ6qvIOwgtN8z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/ForgotPasswordForm.scss
// module id = 1268
// module chunks = 1